import { render, staticRenderFns } from "./drinksPage.vue?vue&type=template&id=59596376&scoped=true&"
import script from "./drinksPage.vue?vue&type=script&lang=js&"
export * from "./drinksPage.vue?vue&type=script&lang=js&"
import style0 from "./drinksPage.vue?vue&type=style&index=0&id=59596376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59596376",
  null
  
)

export default component.exports